export const LABELS = {
  emailLinkMfa: 'Login.MFA.ErrorPage.EmailLink',
  contactUsMfa: 'Login.MFA.IncomingCall.Link.Contact_us',
  contactUsClient: 'Login.ClientLogin.Generic.Link.Contact_us',
  contactUsGeneral: 'Login.Generic.Link.Contact_us',

  invalidCredentials: 'Login.ClientLogin.Validation.Forgot_password.Invalid_credentials',
  accountIsNotReachable: 'Login.ClientLogin.Validation.Generic.Account_is_not_reachable',
  emailIsNotRegistered: 'Login.ClientLogin.Validation.Forgot_password.Email_is_not_registered',
  userNotExternal: 'msgLoginError_UserNotExternal',
  accountIsLocked: 'Login.ClientLogin.Validation.Generic.Account_is_locked',
  invalidClientName: 'msgLoginError_InvalidClientName',
  SSOonly: 'Login.Validation.Generic.SSOonly',
  invalidSsoClientConfig: 'msgLoginError_InvalidSsoClientConfig',
  invalidSamlToken: 'msgLoginError_InvalidSamlToken', //Entity: Portal admin
  invalidEmail: 'Login.ClientLogin.Validation.Forgot_password.Invalid_email',

  generalInvalidCredentials: 'Login.Validation.External.Invalid_credentials',
  generalAccountIsNotReachable: 'Login.Validation.Generic.Account_is_not_reachable',
  generalEmailIsNotRegistered: 'Login.Validation.Forgot_password.Email_is_not_registered',
  generalClientNotFound: 'Login.Validation.Generic.Client_not_found',
  generalAccountIsLocked: 'Login.Validation.Generic.Account_is_locked',
  generalForgotPassword: 'Login.Validation.Forgot_password.Invalid_credentials',

  aboutTrueView: 'Login.Popup.Title.AboutTrueView',
  aboutTrueViewBody: 'Login.Popup.AboutTV.Body',
  aboutTrueViewClose: 'Login.Popup.AboutTV.Close',
  aboutTrueViewButton: 'Login.Button.AboutTrueView',

  clientVersion: 'Clientloginpage.Web.UIStatic.Version',
  version: 'Login.General.Page.Version',

  generalPageTitle: 'General.PageTitle.TrueView',
  generalErrorTitle: 'General.External.Validation.Title.Error',
  generalErrorRetryButton: 'General.External.Validation.Button.Retry',

  offlineErrorText: 'General.External.Validation.Label.No_internet_connection',
  errorText403: 'General.Login.External.Validation.Button.Login_failed',

  loginErrorTitle: 'Login.Errors.page.Title',
  loginErrorText: 'Login.Errors.page.Text',
  loginErrorLink: 'Login.Errors.page.Link',

  termsErrorTitle: 'TermsAndConditions.Error.Web.VersionUpdatedTitle', // Entity: Terms & conditions
  termsErrorText: 'TermsAndConditions.Error.Web.VersionUpdatedMessage',
  termsErrorButton: 'TermsAndConditions.Error.Web.VersionUpdatedButton',

  SSOTitle: 'Login.ClientLogin.Page.Login.Title.Single_sign_on',
  SSOText: 'Login.ClientLogin.Page.Login.Text.SSO_account',
  SSOButton: 'Login.ClientLogin.Page.Login.Button.Proceed',
  clientOR: 'Clientloginpage.Web.UIStatic.OR',
  CIAMTitle: 'Login.ClientLogin.Page.Login.Title.Login',
  CIAMText: 'Clientloginpage.Web.UIStatic.ProceedWithThisOption',
  CIAMButton: 'Clientloginpage.Web.UIStatic.ProceedToCiam',

  extLoginTitle: 'Login.External.Page.Login.Title',
  // extLoginSubTitle: 'Login.External.Page.Subtitle', // TODO: remove this label
  extLoginWithClientTitle: 'Login.External.Page.Login_with_client_name.Title',
  extLoginWithClientButton: 'Login.External.Page.Login_with_client_name.Button.Continue',
  extLoginWithClientLabel: 'Login.External.Page.Login_with_client_name.Field.Client_name', // TODO: remove this label
  extLoginWithClientPlaceholder: 'Login.External.Page.Login_with_client_name.Field.Client_name.Placeholder', // TODO: remove this label
  extLoginWithEmailLabel: 'Login.Login_with_email.Label', // Email or Client
  extLoginWithEmailPlaceholder: 'Login.Login_with_email.Placeholder', // Enter your email
  extLoginFieldRequired: 'Login.Internal.Validation.Required.Field',
  extLoginEmailInvalidFormat: 'Login.Internal.Validation.Email.Field', // Invalid email format
  extLoginEmailServerError: 'Login.Internal.Validation.Email.ServerError', // Invalid user email
  extLoginWithClientMaxLengthError: 'Login.External.Validation.ClientName.MaxLengthError',
  extLoginSelectPortalTitle: 'Login.External.Page.SelectPortal.Title', // Select portal
  extLoginSelectPortalLoadMore: 'Login.External.Page.SelectPortal.LoadMore', // Load more

  generalOr: 'Login.General.Page.Or',
  generalProceed: 'Login.Internal.Page.Login.Button.Proceed',
  generalButtonBack: 'Login.Generic.Button.Back',
  generalButtonCancel: 'General.Buttons.Title.Cancel', // Entity: General

  extSelectLangTitle: 'Login.External.Page.Select_language.Title',
  extSelectLangDropdown: 'Login.External.Page.Select_language.Text_for_dropdown',
  extSelectLangSingle: 'Login.External.Page.Select_language.Text_for_single',
  extSelectLangButton: 'Login.External.Page.Select_language.Button.Continue',

  termsTitle: 'TermsAndConditions.General.Web.Title', // Entity: Portal admin
  termsDownload: 'TermsAndConditions.General.Web.Download', // Entity: Portal admin
  termsAccept: 'TermsAndConditions.General.Web.IAcceptTermsAndConditions', // Entity: Portal admin
  termsAcceptButton: 'TermsAndConditions.General.Web.Accept',
};
